import { render } from "./DialogCustGroupsAddRemove.vue?vue&type=template&id=432ac492"
import script from "./DialogCustGroupsAddRemove.vue?vue&type=script&lang=js"
export * from "./DialogCustGroupsAddRemove.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__